import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { registerServiceWorker } from './app/offlineCache';
import 'bootstrap-icons/font/bootstrap-icons.css';
// The product's own typeface, bundled rather than hoped for: `Barlow` was named
// in the stylesheet and never loaded, so every device drew its own system font.
import '@fontsource/barlow/400.css';
import '@fontsource/barlow/500.css';
import '@fontsource/barlow/600.css';
import '@fontsource/barlow/700.css';
import '@fontsource/barlow/800.css';
import './styles.css';
import './styles/session.css';
import './styles/design.css';
import './styles/direction.css';
import './styles/mission.css';
import './styles/campaign.css';
import './styles/servers.css';
import './styles/proves.css';
import './styles/reports.css';
import './styles/admin.css';
import './styles/profile.css';
import './styles/catalog.css';
import './styles/changelog.css';
import './styles/roadmap.css';
import './styles/inspections.css';

// Only a built app has `/sw.js` (vite.config.ts); the dev server serves none.
if (import.meta.env.PROD) registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
